module.exports = __webpack_public_path__ + "static/media/breakfast5.a4830bfc.png";